import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';
import { IAPIFetchResponse, IAPIListRequestOptions, IAPIListResponse } from '@sondermind/utilities/models-http';
import { camelCaseTransformer } from '@sondermind/utilities/tools';

import { IEnhancedBio } from '../models/enhanced-bio.model';

@Injectable({ providedIn: 'root' })
export class EnhancedBioHttpService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpService
  ) {}

  getByProviderId(personaProviderId: number, apiOpts: Partial<IAPIListRequestOptions> = {}): Observable<IEnhancedBio[] | null> {
    const url = `${this.configurationService.env.svcBase}/provider_profiles/persona_providers/${personaProviderId}/enhanced_bios`;
    const params = this.http.generateListParams(apiOpts);

    return this.http
      .get<IAPIListResponse<IEnhancedBio>>(url, params)
      .pipe(
        map((resp) => camelCaseTransformer<IEnhancedBio[]>(resp.data)),
        this.http.handleHttpError()
      );
  }

  deactivate(bioId: string): Observable<IEnhancedBio | null> {
    const url = `${this.configurationService.env.svcBase}/provider_profiles/enhanced_bios/${bioId}/deactivate`;
    return this.http.post<IAPIFetchResponse<IEnhancedBio>>(
      url, {}
    ).pipe(
      map((resp) => camelCaseTransformer<IEnhancedBio>(resp.data)),
      this.http.handleHttpError()
    );
  }

  activate(bioId: string): Observable<IEnhancedBio | null> {
    const url = `${this.configurationService.env.svcBase}/provider_profiles/enhanced_bios/${bioId}/activate`;
    return this.http.post<IAPIFetchResponse<IEnhancedBio>>(
      url, {}
    ).pipe(
      map((resp) => camelCaseTransformer<IEnhancedBio>(resp.data)),
      this.http.handleHttpError()
    );
  }
}
